module.exports = __webpack_public_path__ + "img/fondo_suelo_noche.60901e27.png";